import React from "react";
import { Button, ButtonGroup } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButtonGroup = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Contained primary button group(Default)"}
        value={
          '<ButtonGroup aria-label="contained primary button group">\n\t<Button>One</Button>\n\t<Button>Two</Button>\n\t<Button>Three</Button>\n</ButtonGroup>'
        }
      >
        <ButtonGroup aria-label="contained primary button group">
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
        </ButtonGroup>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonGroup;
